/**
 * Configuração de Analytics e Tracking
 *
 * IMPORTANTE: Substitua os IDs de exemplo pelos IDs reais quando disponíveis:
 * - Google Analytics 4: Obtenha em https://analytics.google.com/
 * - Facebook Pixel: Obtenha em https://business.facebook.com/events_manager
 */

// Type definitions for global analytics functions
interface GTagFunction {
  (command: 'event', eventName: string, params?: Record<string, unknown>): void;
  (command: 'config', measurementId: string, params?: Record<string, unknown>): void;
}

interface FbqFunction {
  (command: 'trackCustom', eventName: string, params?: Record<string, unknown>): void;
  (command: 'track', eventName: string): void;
}

interface WindowWithAnalytics {
  gtag?: GTagFunction;
  fbq?: FbqFunction;
}

declare const window: Window & WindowWithAnalytics;

export const ANALYTICS_CONFIG = {
  // Google Analytics 4
  googleAnalytics: {
    enabled: false, // Ativar quando tiver o ID real
    measurementId: 'G-XXXXXXXXXX', // Substitua pelo ID real do GA4
  },

  // Facebook Pixel
  facebookPixel: {
    enabled: false, // Ativar quando tiver o ID real
    pixelId: '000000000000000', // Substitua pelo ID real do Facebook Pixel
  },

  // Eventos personalizados para tracking
  events: {
    // Landing Page
    VIEW_PRICING: 'view_pricing',
    VIEW_DEMO: 'view_demo',
    CLICK_CTA: 'click_cta',

    // Early Adopters
    SIGNUP_INTEREST: 'signup_interest',
    FORM_SUBMIT: 'form_submit',

    // Investidores
    VIEW_INVESTOR_PAGE: 'view_investor_page',
    DOWNLOAD_DECK: 'download_deck',
    SCHEDULE_MEETING: 'schedule_meeting',

    // Conversão
    SIGNUP_START: 'signup_start',
    SIGNUP_COMPLETE: 'signup_complete',
    TRIAL_START: 'trial_start',
  }
};

/**
 * Utilitário para enviar eventos personalizados
 */
export const trackEvent = (eventName: string, params?: Record<string, unknown>) => {
  // Google Analytics 4
  if (ANALYTICS_CONFIG.googleAnalytics.enabled && typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }

  // Facebook Pixel
  if (ANALYTICS_CONFIG.facebookPixel.enabled && typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }

  // Log para desenvolvimento
  if (import.meta.env.DEV) {
    console.log(' Analytics Event:', eventName, params);
  }
};

/**
 * Utilitário para tracking de pageview
 */
export const trackPageView = (url: string, title: string) => {
  // Google Analytics 4
  if (ANALYTICS_CONFIG.googleAnalytics.enabled && typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', ANALYTICS_CONFIG.googleAnalytics.measurementId, {
      page_path: url,
      page_title: title,
    });
  }

  // Facebook Pixel
  if (ANALYTICS_CONFIG.facebookPixel.enabled && typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }

  // Log para desenvolvimento
  if (import.meta.env.DEV) {
    console.log(' Page View:', url, title);
  }
};
